import { defineComponent as _defineComponent } from 'vue'
import DetailAccordion from '@/components/DetailAccordion.vue';
import DisplayInput from '@/components/inputs/DisplayInput.vue';
import { isEmpty, isNil, valueOrDefault } from '@/utils/misc';
import {
  isPresetAlert,
  translateKpi,
  translateOperator,
  translateSeverity,
  translateStatus,
  translateType,
  translateVariable,
} from '@/utils/alerts';
import { useI18n } from '@/composables/i18n';
import { CareAlert } from '@/models/careAlert';
import DisplayDatepicker from '@/components/inputs/DisplayDatepicker.vue';
import { translateFilterTimeAxisSpanEnum } from '@/utils/i18n';
import DisplayTaginput from '@/components/inputs/DisplayTaginput.vue';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CareAlertDetailModal',
  props: {
    alert: null
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as {
  alert: CareAlert;
};





const hasVariable = computed<boolean>(
  () => !isNil(props.alert.variable),
);

const hasSources = computed<boolean>(
  () => !isEmpty(props.alert.eventSources),
);

const hasEventCodes = computed<boolean>(
  () => !isEmpty(props.alert.eventCodes),
);

const { t } = useI18n();

return { __sfc: true,props, emit, hasVariable, hasSources, hasEventCodes, t, DetailAccordion, DisplayInput, valueOrDefault, isPresetAlert, translateKpi, translateOperator, translateSeverity, translateStatus, translateType, translateVariable, DisplayDatepicker, translateFilterTimeAxisSpanEnum, DisplayTaginput }
}

})